<template>
  <div id="bg-image">
    <get-started-page />
  </div>
</template>

<script>
import GetStartedPage from '../process/Register/GetStartedPage.vue';
  export default {
      name: 'GetStarted',
      components: {
          GetStartedPage,
      },
  };
</script>

<style scoped>
</style>
